import { Game } from '../Game'

export function PlinkoGamePage() {
  return <Game />
}
